import { styled } from '@metrika/ui-kit/emotion';

export const CenterContent = styled.div`
   height: 100vh;
   margin: 0;
   width: 100vw;
   position: relative;
   padding-top: 3rem;
   display: flex;
   align-items: center;
   justify-content: center;
`;
